










































































import { Component, Prop, Vue } from "vue-property-decorator";
import { RENO_COMMENT_MAX_LENGTH, RenoReview } from "@/data/models/RenoReviewEntry";
import { COLOR_CHAIN_SUSPECT, COLOR_SUPPRESSED } from "@/utils/colors";

/**
 * Identity of the drying under review, plus everything the reviewer can record about it that is not
 * a quality verdict: a free-text comment, a report that the program chain looks wrong, and hiding it.
 *
 * The two buttons are **toggles, and neither navigates**. Both are independent of the 1-4 verdict, so
 * a drying can be reported, hidden and scored at once, and either mark can be taken back.
 *
 * Presentation only. The parent owns persistence, because the comment and the report share one
 * document and each mark has its own failure path.
 */
@Component
export default class RenoReviewNoteRowComponent extends Vue {
  /** Program chain id, the identifier that ties a rating back to a prediction. */
  @Prop({ default: "" }) chainId!: string;

  /** RENO model version the queue is scoped to, so it is never ambiguous what was judged. */
  @Prop({ default: "" }) modelVersion!: string;

  /** Current comment text, owned by the parent so navigation can flush it. */
  @Prop({ default: "" }) comment!: string;

  /** Whether this drying is currently marked as having a broken program chain. */
  @Prop({ default: false }) chainSuspect!: boolean;

  /** The verdict already stored for this drying and model version, if the reviewer has been here. */
  @Prop({ default: null }) savedReview!: RenoReview | null;

  /** Whether the reviewer has hidden this drying. Independent of any rating, and it survives releases. */
  @Prop({ default: false }) isSuppressed!: boolean;

  /** Blocks input while a save is in flight, so a fast reviewer cannot outrun the write. */
  @Prop({ default: false }) isSaving!: boolean;

  /**
   * Which of the two buttons is the one being waited for, so it spins instead of just greying out.
   *
   * `isSaving` disables everything in the row; these say which press caused it. Without them a slow
   * report or hide looked like a dead button, and the reviewer pressed again.
   */
  @Prop({ default: false }) isReportingChain!: boolean;

  /** @see isReportingChain */
  @Prop({ default: false }) isSuppressing!: boolean;

  maxLength = RENO_COMMENT_MAX_LENGTH;

  get chainSuspectColor(): string {
    return COLOR_CHAIN_SUSPECT;
  }

  get suppressedColor(): string {
    return COLOR_SUPPRESSED;
  }

  /**
   * What this reviewer scored the drying last time.
   *
   * Only the rating: the two marks now show their own state in the buttons that set them, so a line
   * repeating "you hid this" beside a button that is visibly pressed says nothing.
   */
  get savedLabel(): string {
    return this.savedReview
      ? this.$t("admin.renoReview.rating.previously", [this.savedReview.rating]).toString()
      : "";
  }
}
